import { render, staticRenderFns } from "./IconEkgygjss.vue?vue&type=template&id=413f5597"
import script from "./IconEkgygjss.vue?vue&type=script&lang=js"
export * from "./IconEkgygjss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports